import {fabric} from 'fabric';

export function addNewImage(canvas,localimageURL){
  /*  var reader = new FileReader();
    reader.onload = function (event){
      var imgObj;
      imgObj= new Image();
      imgObj.src = event.target.result;
      imgObj.onload = function () {
        var image = new fabric.Image(imgObj);
        image.set({
              angle: 0,
              padding: 10,
              cornersize:10,
              
        });
        image.scaleToHeight(300);
        image.scaleToWidth(300);
        canvas.centerObject(image);
        canvas.add(image);
        canvas.renderAll();
      }
    }
    reader.readAsDataURL(localimage);
    */
    if(localimageURL.length>0){
    // let n=localimageURL.length;
    // let imgObj = new Image();
    // imgObj.src = localimageURL[n-1].imageUrl;
    // imgObj.onload = function ()
    // {
    //     let image = new fabric.Image(imgObj);
    //     image.set({
    //         angle: 0,
    //         padding: 0,
    //         left:fabric.util.getRandomInt(200, canvas.width-100 ),
    //         top:fabric.util.getRandomInt(100, canvas.height-200),
    //         originX: "center",
    //         originY: "center"
    //     });
    //     image.scaleToHeight(450);
    //     image.scaleToWidth(450);
    //     canvas.add(image);

    // }
    fabric.Image.fromURL(localimageURL, function (oImg) {
      oImg.set({
        angle: 0,
        padding: 0,
        editable:true,
        left:fabric.util.getRandomInt(200, canvas.width-100 ),
        top:fabric.util.getRandomInt(100, canvas.height-200),
        originX: "center",
        originY: "center"
    });
    oImg.scaleToHeight(450);
    oImg.scaleToWidth(450);
    canvas.add(oImg);
    canvas.sendToBack(oImg);
    }, { crossOrigin: 'Anonymous' });
  }

    

}